const TYPES = {
    FLAT: 0,
    FULL_SCREEN: 1
};

export { TYPES };